import styled from "styled-components";

export default c => styled(c)`
  position: relative;
  width: 100%;

  .background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    transition: opacity 250ms;
    background: ${props =>
      props.dark ? "rgba(0, 0, 0, 0.65)" : "rgba(255, 255, 255, 0.65)"};
    /*display: ${props => (props.loading ? "block" : "none")};
    opacity: ${props => (props.loading ? "1" : "0")};*/
  }

  .loader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;



// WEBPACK FOOTER //
// ./src/components/support/loadable/style.js